import VueI18n    from 'vue-i18n';



window.Handlebars = Handlebars;
window.$          = window.jQuery = require('jquery');
window._          = require('lodash');
window.axios      = require('axios');
window.Vue        = require('vue');
window.printf     = require('printf');
window.n          = require('./n');

require('./bootstrap-x');
require('jquery.cookie');

let lang        = document.documentElement.lang;
if(['en', 'fr', 'it', 'de', 'es', 'pt'].indexOf(lang) === -1) {
    lang = 'en';
}
console.log(lang);
let messages      = { };
messages[lang]    = require('./i18n/' + lang);

window.i18n = new VueI18n({
    locale:   lang,
    messages: messages
});



Vue.component('v-accept',   require('./components/cookiePanel'));
Vue.component('v-auth',     require('./components/auth.vue'));

Vue.use(i18n);

new Vue({

    el: '#main',
    i18n,
    data() {
        return {}
    },
});







// WEBPACK FOOTER //
// ./resources/js/app_vue_main.js